import { render, staticRenderFns } from "./TableReutilizablePrint.vue?vue&type=template&id=a08aa78a"
import script from "./TableReutilizablePrint.vue?vue&type=script&lang=js"
export * from "./TableReutilizablePrint.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports